import * as Sentry from "@sentry/vue";
import type { App } from "vue";

export function initSentry(app: App) {
    if (!import.meta.env.PROD) {
        return;
    }
    Sentry.init({
        app,
        dsn: "https://61689a8558726a64ce3ef2ee67d1982e@o4511645794041856.ingest.us.sentry.io/4511669585772544",
        sendDefaultPii: true,
        enableLogs: true,
        integrations: [
            Sentry.browserTracingIntegration(),
            // Sentry.replayIntegration({ // 
            //     maskAllText: true,
            //     blockAllMedia: true,
            // }),
            Sentry.consoleLoggingIntegration({
                levels: ['debug', 'info', 'warn', 'error', 'log', 'assert', 'trace'],
            }),
        ],
        tracesSampleRate: 1.0,
        replaysSessionSampleRate: 0.1,
        replaysOnErrorSampleRate: 1.0,
        environment: import.meta.env.MODE,
        release: import.meta.env.PUBLIC_SOURCE_COMMIT,
    });
}
